<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

  <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <center>
          <div class="d-flex justify-content-between align-items-center">
            <p style="font-size: 2vw"> اطلاعات مالی    / {{$route.params.title}}</p>
            <button @click.prevent="$router.back()"  class="btn btn-primary btn-approve  ">برگشت</button>
          </div>
          <hr>
          <br>
        </center>
        <div class="d-flex flex-nowrap ">
          <div class="card p-4 w-50">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">تعریف ساختار صورت وضعیت مالی  </p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Financial_management_and_productivity/functional_information/wealths/by/${id_route}/${$route.params.title}`" >تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>
          <div class="card p-4 w-50 mx-2">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">تعریف ساختار سود و زیان </p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Financial_management_and_productivity/functional_information/profit_and_loss_structures/by/${id_route}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>
          <div class="card p-4 w-50 mx-2">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">تعریف صورت جریان وجوه نقد </p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-100" :to="`/Financial_management_and_productivity/functional_information/cashes/by/${id_route}/${$route.params.title}`">تکمیل اطلاعات / بروزرسانی</router-link>
            </center>
          </div>
        </div>




      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";

export default {
  components: {
    Sidebar,
    splash
  },
  data(){
    return{
      id_route: this.$route['params']['id'],
    }
  },
}
</script>
